var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#555",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#555",
    strokeWidth: 4.096,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.087,144.696c-18.412,0-33.391,14.979-33.391,33.391c0,18.412,14.979,33.391,33.391,33.391 c18.412,0,33.391-14.979,33.391-33.391C211.478,159.675,196.499,144.696,178.087,144.696z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.913,144.696c-18.412,0-33.391,14.979-33.391,33.391c0,18.412,14.979,33.391,33.391,33.391 c18.412,0,33.391-14.979,33.391-33.391C367.304,159.675,352.325,144.696,333.913,144.696z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.842,0,0,114.842,0,256s114.842,256,256,256s256-114.842,256-256S397.158,0,256,0z M256,478.609 c-122.746,0-222.609-99.862-222.609-222.609S133.254,33.391,256,33.391S478.609,133.254,478.609,256S378.746,478.609,256,478.609z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.13,239.304c-9.22,0-16.696,7.475-16.696,16.696c0,67.511-54.924,122.435-122.435,122.435 c-67.51,0-122.435-54.924-122.435-122.435c0-9.22-7.475-16.696-16.696-16.696S100.174,246.78,100.174,256 c0,85.923,69.904,155.826,155.826,155.826S411.826,341.922,411.826,256C411.826,246.78,404.351,239.304,395.13,239.304z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyHeart);
export default __webpack_public_path__ + "static/media/happy-heart.31e45259a410245daaca2ba9812e72ae.svg";
export { ForwardRef as ReactComponent };